module.exports = __webpack_public_path__ + "img/icon-checkmarklight-blue.caf44209.svg";